/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { ArrowRight, Timer } from '@/components/Svg';
import CPaginationWithLinks from '@/components/main/CPaginationWithLinks';
import { Card, Container, Grid } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import dayjs from 'dayjs';
import RelativeTime from 'dayjs/plugin/relativeTime';
import Link from 'next/link';
import { useParams, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import Image from 'next/image';
dayjs.extend(RelativeTime);

const BlogsPage = ({ dictionary, blogsPostData, tag }) => {
  const params = useParams();
  const searchParams = useSearchParams();
  const [searchItems, setSearchItems] = useState({});
  const [count, setCount] = useState(0);
  useEffect(() => {
    setCount(blogsPostData?.count ?? 0);
  }, []);

  useEffect(() => {
    let temp = {};

    for (let [key, value] of searchParams.entries()) {
      if (key == 'tag') {
        value = searchParams.getAll('tag');
      }
      temp[key] = value;
    }
    setSearchItems(temp);
  }, [searchParams]);

  return (
    <>
      <Container className="my-10">
        {tag ? <p className="text-primary py-1 font-semibold mb-3 text-[24px]">#{tag}</p> : null}
        <Grid>
          {blogsPostData?.data?.length == 0 && (
            <div className="mx-auto my-20 text-center">
              <IconAlertCircle size={100} className="mx-auto text-primary" />
              <div className=" text-[30px] font-semibold text-center text-greyDark mx-auto">
                {dictionary.noResultsFound}
              </div>
              <p className="text-textGrey">{dictionary.noResultsFoundCheckFilters}</p>
            </div>
          )}
          {blogsPostData?.data?.map((blogPost, index) => (
            <Grid.Col sm={12} md={6} lg={4} key={index}>
              <Card key={index} padding="lg" radius="md" withBorder className="max-w-[400px]">
                <Card.Section>
                  <Link
                    href={`/blogs/${blogPost?.id}`}
                    className="relative min-h-[250px] block bg-gray-200"
                  >
                    {blogPost?.file && (
                      <>
                        <Image
                          height={250}
                          width={400}
                          src={blogPost?.file?.url}
                          blurDataURL={blogPost?.file?.compressed ?? blogPost?.file?.url}
                          alt={blogPost?.title}
                          placeholder="blur"
                          className="object-cover object-center "
                        />
                      </>
                    )}
                  </Link>
                </Card.Section>
                <Link href={`/blogs/${blogPost?.id}`} className="no-underline ">
                  <h3 className="m-0 mt-3 text-[18px] font-bold  text-grayCustom cursor-pointer hover:text-primary transition-all duration-200">
                    {blogPost?.title}
                  </h3>
                </Link>
                <div className="flex items-center my-2 text-primary">
                  <Timer height="18" width="18" />
                  <p className="ms-2 text-textGrey">{dayjs(blogPost?.createdAt).fromNow()}</p>
                </div>
                <p className="text-textGrey min-h-[75px] line-clamp-3 overflow-hidden text-ellipsis...">
                  {blogPost?.excerpt}
                </p>
                <div className="mt-3 text-primary">
                  <Link
                    href={`/blogs/${blogPost?.id}`}
                    className="flex items-center font-bold no-underline text-primary me-2 "
                  >
                    <div>{dictionary.readMore}</div>
                    <div className="ms-2">
                      <ArrowRight width="18" />
                    </div>
                  </Link>
                </div>
              </Card>
            </Grid.Col>
          ))}
        </Grid>
        <CPaginationWithLinks
          value={parseInt(params?.page ?? 1)}
          totalPages={Math.ceil(parseInt(count) / 12)}
          dictionary={dictionary}
          searchItems={searchItems}
        />
      </Container>
    </>
  );
};

export default BlogsPage;
